import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavigationHistory } from '../../hooks/useNavigationHistory';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const BackButton = () => {
  const navigate = useNavigate();
  const { handleBack, canGoBack } = useNavigationHistory();

  const handleClick = () => {
    if (canGoBack) {
      handleBack();
    } else {
      navigate(-1); // Fallback to browser's history
    }
  };

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={handleClick}
      sx={{
        color: '#3B3B3B',
        textTransform: 'none',
      }}
    >
      Back
    </Button>
  );
}; 